import { Backdrop } from "@mui/material"
import { CloseCircle } from "iconsax-react"
import { useState } from "react"
import { useIsMobile } from "src/hooks/useIsMobile"
import MainCard from "../main-card"

// -------------------------------------------------|| GENERAL MODAL - COMPONENTS ||-------------------------------------------------

const GeneralModal = ({ open, children }) => {
  const [openModal, setOpenModal] = useState(open)
  const isMobile = useIsMobile()
  const handleClose = () => {
    setOpenModal(false)
  }
  return (
    <Backdrop open={openModal} sx={{ zIndex: 1000000 }} fullWidth={true}>
      <MainCard
        shadow={3}
        sx={
          isMobile
            ? { p: 3, borderRadius: "18px", zIndex: 10000000, cursor: "pointer", width: "90%" }
            : { p: 3, borderRadius: "18px", zIndex: 10000000, cursor: "pointer" }
        }
      >
        <CloseCircle color='grey' size={32} onClick={handleClose} />
        {children}
      </MainCard>
    </Backdrop>
  )
}
export default GeneralModal
